<template>
	<el-dialog :title="!dataForm.recId ? '旁站登记' : '旁站修改'" :close-on-click-modal="false" :visible.sync="visible"
		width="910px">
		<el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="110px" :inline="true" class="border-form">
			<el-row class="set_border">
				<el-col :span="12" class="col-set_border">
					<el-form-item label="标的物" prop="subjectNo" class="item">
						<el-select class="selItemInput" v-model="dataForm.subjectNo" placeholder="请选择">
							<el-option v-for="item in subjectList" :key="item.displayValue"
								:label="item.displayName" :value="item.displayValue">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="旁站项目" prop="onsiteItem" class="item">
						<el-input class="selItemInput" type="input" v-model="dataForm.onsiteItem"
							placeholder="请填写"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="set_border">
				<el-col :span="12" class="col-set_border">
					<el-form-item label="旁站部位" prop="onsitePosition" class="item">
						<el-input class="selItemInput" type="input" v-model="dataForm.onsitePosition"
							placeholder="请填写"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="开始时间" prop="beginTime" class="item">
						<el-date-picker class="selItemInput" v-model="dataForm.beginTime" type="date"
							value-format="yyyy-MM-dd" placeholder="选择日期">
						</el-date-picker>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="set_border">
				<el-col :span="24">
					<el-form-item label="旁站人" prop="bystander" class="item">
						<el-input class="selItemInput1" type="input" v-model="dataForm.bystander"
							placeholder="请填写"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="set_border">
				<el-col :span="24">
					<el-form-item label="旁站内容" prop="onsiteContent" class="item">
						<el-input class="selItemInput1" type="textarea" rows="3" v-model="dataForm.onsiteContent"
							placeholder="请填写"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="set_border">
				<el-col :span="24">
					<el-form-item label="参与人" class="item">
						<el-input class="selItemInput1" type="textarea" rows="3" v-model="dataForm.participants"
							placeholder="请填写"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="formBtnGroup">
				<el-button v-preventReClick class="btn" type="primary" size="small" @click="dataFormSubmit()">确定</el-button>
				<el-button v-preventReClick class="rebtn" size="small" @click="visible = false">取消</el-button>
			</el-row>
		</el-form>
	</el-dialog>
</template>

<script>
import addImg from "@/assets/images/addImg.png"
import $common from "@/utils/common.js"
export default {
	name: "problem-add-or-update",
	data() {
		return {
			addImg: addImg,
			id: "",
			visible: true,
			form: {},
			action: "",
			subjectList: [],
			dataForm: {
				workNo: $common.getItem("workNo"),
				recId: "",
				subjectNo: "",
				participants: "",
				onsitePosition: "",
				onsiteItem: "",
				onsiteContent: "",
				bystander: "",
				beginTime: "",
				category: "",
			},
			dataRule: {
				subjectNo: [
					{ required: true, message: "标的物不能为空", trigger: "blur" }
				],
				onsiteItem: [
					{ required: true, message: "旁站项目不能为空", trigger: "blur" }
				],
				onsitePosition: [
					{ required: true, message: "旁站部位不能为空", trigger: "blur" }
				],
				beginTime: [
					{ required: true, message: "开始时间不能为空", trigger: "blur" }
				],
				bystander: [
					{ required: true, message: "旁站人不能为空", trigger: "blur" }
				],
				onsiteContent: [
					{ required: true, message: "旁站内容不能为空", trigger: "blur" }
				],

			},
		};
	},
	components: {

	},
	methods: {
		init(id, category, subjectNo) {
			this.dataForm = {
				workNo: $common.getItem("workNo"),
				recId: "",
				subjectNo: "",
				participants: "",
				onsitePosition: "",
				onsiteItem: "",
				onsiteContent: "",
				bystander: "",
				beginTime: ""
			}
			this.dataForm.recId = id ? id : 0;
			this.dataForm.category = category;
			this.dataForm.subjectNo = subjectNo
			this.getSubjectDropDown()
			if (id) {
				this.getDetail();
			}
			this.$nextTick(() => {
				this.visible = true;
			})
		},
		getSubjectDropDown() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/index/getSubjectDropDown/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.code === 200) {
					this.subjectList = data.body;
				}
			});
		},
		getDetail() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/onsiteinfo/info/" + this.dataForm.recId,
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.code === 200) {
					this.dataForm = data.body
				}
			});
		},
		dataFormSubmit() {
			if (this.dataForm.subjectNo == null || this.dataForm.subjectNo == "") {
				this.$message.error("标的物不能为空");
				return;
			}
			if (this.dataForm.onsiteItem == null || this.dataForm.onsiteItem == "") {
				this.$message.error("旁站项目不能为空");
				return;
			}
			if (this.dataForm.onsitePosition == null || this.dataForm.onsitePosition == "") {
				this.$message.error("旁站部位不能为空");
				return;
			}
			if (this.dataForm.beginTime == null || this.dataForm.beginTime == "") {
				this.$message.error("开始时间不能为空");
				return;
			}
			if (this.dataForm.bystander == null || this.dataForm.bystander == "") {
				this.$message.error("旁站人不能为空");
				return;
			}
			if (this.dataForm.onsiteContent == null || this.dataForm.onsiteContent == "") {
				this.$message.error("旁站内容不能为空");
				return;
			}


			this.$refs["dataForm"].validate(valid => {
				if (valid) {
					let _url = "/business/onsiteinfo/save";
					if (this.dataForm.recId && this.dataForm.recId != 0) {
						_url = "/business/onsiteinfo/update";
					}
					this.$http({
						url: this.$store.state.httpUrl + _url,
						method: "post",
						data: this.$http.adornData(this.dataForm)
					}).then(({ data }) => {
						if (data && data.code === 200) {
							this.$message({
								message: "操作成功",
								type: "success",
								duration: 1500,
								onClose: () => {
									this.visible = false;
									this.$emit("refreshDataList");
								}
							});
						} else {
							this.$message.error(data.msg);
						}
					});
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped="scoped">
.selItemInput.descAreaLg {
	width: 718px !important;
}

.addImgBox {
	width: 136px;
	height: 136px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 10px;
	position: relative;
}

::v-deep .el-form-item {
	display: flex !important;
	align-items: stretch !important;
	margin-bottom: 0px !important;
}

.border-form .el-row.set_border {
	border-bottom: solid #dadada 1px;
	border-left: solid #dadada 1px;
	border-right: solid #dadada 1px;
}

.border-form .el-row.set_border:first-child {
	border-top: solid #dadada 1px;
}

.border-form .el-row.set_border .col-set_border {
	border-right: solid #dadada 1px;
}

.item::v-deep .el-form-item__label {
	color: #00428E !important;
	margin-right: 10px !important;
	font-weight: bold !important;
	background-color: #E1F1FF;
	white-space: nowrap !important;
	border-right: 1px solid #DADADA;
}

.selItemInput1 {
	width: 695px !important;
}
</style>
